<coin-v2-button
  type="secondary"
  icon="help_outline"
  iconPos="right"
  [text]="'general.view-information-button' | translate"
  (click)="openInformationDialog()"></coin-v2-button>
